import { createAction } from '@reduxjs/toolkit';

export const setIsUserNotFound = createAction<boolean>(
  'app/authentication/login/setIsUserNotFound'
);

export const setIsButtonDisabled = createAction<boolean>(
  'app/authentication/login/setIsButtonDisabled'
);
